module.exports = __webpack_public_path__ + "img/11.a24e7a47.jpg";